import * as React from 'react';
import styled from 'styled-components';

export interface Props {
  color?: string;
  width?: string;
  height?: string;
  radius?: string;
  fontSize?: string;
  style?: React.CSSProperties;
  click?: (e?) => void;
  fullWidthOnMobile?: boolean;
  largetOnMobile?: boolean;
  fontColor?: string;
  roundOnMobile?: boolean;
  padding?: string;
  widthOnMobile?: string;
  disabled?: boolean;
  type?: string;
  fontWeight?: string | number;
}

export class Button extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  public render() {
    let fullWidthOnMobile = false;
    let largetOnMobile = false;
    let roundOnMobile = false;
    let widthOnMobile = '';

    if (this.props.fullWidthOnMobile) {
      fullWidthOnMobile = this.props.fullWidthOnMobile;
    }

    if (this.props.largetOnMobile) {
      largetOnMobile = this.props.largetOnMobile;
    }

    if (this.props.roundOnMobile) {
      roundOnMobile = this.props.roundOnMobile;
    }
    if (this.props.widthOnMobile) {
      widthOnMobile = this.props.widthOnMobile;
    }

    const styles = Object.assign(
      {},
      {
        width: this.props.width || '100%',
        height: this.props.height || 'auto',
        borderRadius: this.props.radius || '6px',
        background: this.props.color || 'black',
        padding: this.props.padding || '0',
      },
      this.props.style,
    );

    if (this.props.disabled === true) {
      styles.opacity = 0.5;
      styles.cursor = 'auto';
    }

    return (
      <RectangleComponent
        type={this.props.type}
        style={styles}
        onClick={this.handleClick}
        fullWidthOnMobile={fullWidthOnMobile}
        largetOnMobile={largetOnMobile}
        roundOnMobile={roundOnMobile}
        widthOnMobile={widthOnMobile}
      >
        <Text
          fontSize={this.props.fontSize}
          fontColor={this.props.fontColor}
          fontWeight={this.props.fontWeight}
        >
          {this.props.children}
        </Text>
      </RectangleComponent>
    );
  }

  private handleClick = e => {
    if (this.props.click) {
      this.props.click(e);
    }
  };
}

const RectangleComponent: any = styled.button`
      border: none;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;
      vertical-align: middle;
      border: none;

      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      &:active {
        opacity: 0.6;
      }

      &:focus {
        outline: none;
      }

      ${(props: any) => {
        if (props.widthOnMobile) {
          return `
            @media only screen and (max-width: 500px) {
              width: ${props.widthOnMobile} !important;
            }
          `;
        }

        return '';
      }}

      ${(props: any) => {
        if (props.roundOnMobile) {
          return `
            @media only screen and (max-width: 500px) {
              border-radius: 50px !important;
            }
          `;
        }

        return '';
      }}


      ${(props: any) => {
        if (props.largetOnMobile) {
          return `
            @media only screen and (max-width: 900px) {
              width: auto !important;
              height: auto !important;
              text-transform: uppercase;
              font-size: ${props.theme.fontSizeS};
              border-radius: 2px !important;
            }
          `;
        }

        return '';
      }}


      ${(props: any) => {
        if (props.fullWidthOnMobile) {
          return `
            @media only screen and (max-width: 600px) {
              width: 100% !important;
            }
          `;
        }

        return '';
      }}
};
`;

const Text: any = styled.span`
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${(props: any) => (props.fontColor ? props.fontColor : '#FFFFFF')};
  display: flex;
  align-items: center;
  font-weight: ${(props: any) => (props.fontWeight ? props.fontWeight : '400')};
  ${(props: any) => {
    if (props.fontSize) {
      return `
        font-size: ${props.fontSize}
      `;
    }
    return;
  }};
`;
